// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as z from 'zod';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';

const requestMagicLinkResponseSchema = z
  .object({
    data: z.object({ success: z.boolean() }),
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({
    ...response,
    success: data.success,
  }));

type RequestMagicLinkResponse = z.infer<typeof requestMagicLinkResponseSchema>;

/** Asks the API to email a sign-in link. */
export async function requestMagicLink(
  email: string,
  redirectURL?: string
): Promise<RequestMagicLinkResponse> {
  const response = await api.post('/auth/magic-link', {
    email,
    redirect: redirectURL,
  });

  return parseResponse(requestMagicLinkResponseSchema, response.data, {
    schemaName: 'RequestMagicLink',
    endpoint: '/auth/magic-link',
  });
}
